<template>
  <div class="space-between-y">
    <el-dialog title="问卷编辑" :visible.sync="detail.dialog" append-to-body width="600px">
      <survey-form v-if="detail.dialog" :id="detail.id" @saved="saved()"></survey-form>
    </el-dialog>


    <div class="both-sides">
      <div class="space-between-x container-left">
        <input-item label="请输入关键字搜索">
          <el-input v-model="form.keyword" placeholder="请输入关键字搜索"></el-input>
        </input-item>
        <input-item>
          <el-button type="primary" @click="getData">搜索</el-button>
        </input-item>
      </div>
      <input-item>
        <el-button type="primary" @click="create">创建问卷</el-button>
      </input-item>
    </div>


    <el-table stripe border :data="list">
      <el-table-column width="60" prop="id" label="id"></el-table-column>
      <el-table-column prop="title" label="问卷标题"></el-table-column>
      <el-table-column prop="description" label="问卷标题"></el-table-column>
      <el-table-column prop="status" label="状态"></el-table-column>
      <el-table-column prop="url" label="问卷使用的页面"></el-table-column>
      <el-table-column width="90" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="editQu(scope.row.id)">编辑</el-button>
          <el-button size="mini" type="text" @click="deleteQu(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import {survey} from "@/api/miu/survey";
import InputItem from "@/components/base/layout/InputItem.vue";
import SurveyForm from "@/components/SurveyForm.vue";
import {msg} from "@/assets/js/my-vue-element-ui-js";

export default {
  name: 'SurveyQuestionnaire',
  components: {
    SurveyForm,
    InputItem
  },

  data() {
    return {
      list: [],

      form: {
        keyword: "",
      },

      detail: {
        id: null,
        dialog: false,
      },

    }
  },

  created() {
    this.getData();
    // this.editQu(2);
  },

  methods: {
    editQu(id) {
      this.detail.id = id;
      this.detail.dialog = true;
    },

    saved() {
      this.detail.id = null;
      this.detail.dialog = false;
      this.getData();
    },

    deleteQu(id) {
      survey.deleteQuestionnaire(id).then(res => {
        msg(res, this);
        if (res.code === 200) {
          this.getData();
        }
      })
    },

    create() {
      this.detail.id = null;
      this.detail.dialog = true;
    },

    getData() {
      survey.listQuestionnaire().then(res => {
        this.list = res.data;
      })
    },
  },


};
</script>

<style scoped>
</style>
